import { render, staticRenderFns } from "./DownloadClient.vue?vue&type=template&id=3907b71a&scoped=true&"
import script from "./DownloadClient.vue?vue&type=script&lang=js&"
export * from "./DownloadClient.vue?vue&type=script&lang=js&"
import style0 from "./DownloadClient.vue?vue&type=style&index=0&id=3907b71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907b71a",
  null
  
)

export default component.exports